import { render, staticRenderFns } from "./headerSize.vue?vue&type=template&id=6f39b042&scoped=true"
import script from "./headerSize.vue?vue&type=script&lang=js"
export * from "./headerSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39b042",
  null
  
)

export default component.exports